/** App path for an entity record (search results, notifications, record links). */
export function recordPath(entity: string, id: string): string {
  switch (entity) {
    case "core.organization": return `/organizations/${id}`;
    case "core.contact": return `/contacts/${id}`;
    case "core.product": return `/products/${id}`;
    case "crm.lead": return `/crm/leads/${id}`;
    case "crm.deal": return `/crm/deals/${id}`;
    case "crm.quote": return `/crm/quotes/${id}`;
    case "invoicing.invoice": return `/invoicing/invoices/${id}`;
    case "invoicing.payment": return `/invoicing/payments`;
    case "helpdesk.ticket": return `/helpdesk/tickets?ticket=${id}`;
    case "hr.employee": return `/hr/employees/${id}`;
    case "requests.request": return `/requests/${id}`;
    case "appointments.appointment": return `/appointments/list`;
    case "projects.project": return `/projects/${id}`;
    case "projects.task": return `/tasks?task=${id}`;
    default: return "/";
  }
}
